import apiClient from '../../../common/functions/api_axios_instance.function';
import { notify } from '../../../common/functions/react-toastify.function';

export const createRoleAssignment = async (data) => {
  try {
    // Backend expects { user_id, role_id }
    const requestData = {
      user_id: data.user_id,
      role_id: data.role_id,
    };
    const response = await apiClient.post('/invoiceRoleManagement/assign', requestData);
    return { success: true, data: response.data };
  } catch (error) {
    console.log(error);
    const errorMessage =
      error.response?.data?.message || error.response?.data?.error || 'Failed to assign role';
    notify('error', errorMessage);
    return { success: false, error: errorMessage };
  }
};
